import React from 'react'
import CashSessionManager from '../../components/CashRegister/CashSessionManager'

export default function CashRegister() {
  return <CashSessionManager />
}
